export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00379.8cf7404c.png";